/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCartLabels } from '../../../utils/getCartLabels'
import {
  SummaryCustomFeeProps,
  SummarySubtotalFields
} from './SummaryList.types'
import {
  FeeLabel,
  FeePrice,
  SubTotalLabel,
  SubTotalPrice,
  SummaryTotalContainer
} from './SummaryListTotals/SummaryListTotals.style'

const SummaryCustomFee = (props: SummaryCustomFeeProps) => {
  const {
    summaryFieldsToDisplay,
    customFields,
    priceProps,
    subTotalLabel,
    labelMap
  } = props
  const summaryFields = customFields?.summary
  const subTotalValue = summaryFields?.find(
    (field: { name: string }) => field.name === 'subtotal'
  )?.value
  const subTotalField = summaryFields?.find(
    (field: { name: string }) => field.name === 'subtotal'
  )?.name
  const isVisibleField = (fieldName: string) =>
    summaryFieldsToDisplay?.includes(fieldName as SummarySubtotalFields)

  return (
    <>
      {subTotalLabel && (
        <SummaryTotalContainer>
          <SubTotalLabel>
            {getCartLabels(subTotalLabel, labelMap).label}
          </SubTotalLabel>
          <SubTotalPrice value={subTotalValue} {...priceProps} />
        </SummaryTotalContainer>
      )}
      {summaryFields &&
        summaryFields.map(
          (field: { name: any; value: number | undefined }, index: number) => {
            const fieldName = field.name
            return summaryFields[index].name !== subTotalField &&
              isVisibleField(fieldName) ? (
              <SummaryTotalContainer key={fieldName}>
                <FeeLabel>{getCartLabels(fieldName, labelMap).label}</FeeLabel>
                <FeePrice value={field.value} {...priceProps} />
              </SummaryTotalContainer>
            ) : null
          }
        )}
    </>
  )
}

export default SummaryCustomFee
